// 🔧 promotion_section_card.js
// ✅ Purpose: Standard content container for the LGV Promotion Engine
// ✅ Features:
// - Consistent section layout across Promotion Engine pages
// - Optional title, subtitle, icon, actions, and footer
// - Uniform styling with other LGV admin pages
// - Reusable for dashboards, editors, queues, settings, calendars, and future pages
// - Fully block-commented for clarity and future devs

import React from "react";

/**
 * PromotionSectionCard
 *
 * Standard container used throughout the Promotion Engine.
 *
 * Future uses:
 * - Dashboard sections
 * - Idea Bank
 * - Queue
 * - Scheduler
 * - History
 * - Settings
 * - Campaigns
 * - Analytics
 */
const PromotionSectionCard = ({
  title = "",
  subtitle = "",
  icon = null,
  actions = null,
  footer = null,
  children,
}) => {
  return (
    <div className="card shadow-sm border-0 mb-4">

      {(title || subtitle || icon || actions) && (
        <div className="card-header bg-white border-0 py-3">

          <div className="row align-items-center g-3">

            <div className="col">

              <div className="d-flex align-items-center">

                {icon && (
                  <i
                    className={`${icon} text-success me-3`}
                    style={{ fontSize: "1.5rem" }}
                  />
                )}

                <div>

                  {title && (
                    <h5 className="fw-bold mb-1">
                      {title}
                    </h5>
                  )}

                  {subtitle && (
                    <div className="text-muted small">
                      {subtitle}
                    </div>
                  )}

                </div>

              </div>

            </div>

            {actions && (
              <div className="col-auto">
                <div className="d-flex flex-wrap gap-2">
                  {actions}
                </div>
              </div>
            )}

          </div>

        </div>
      )}

      <div className="card-body">
        {children}
      </div>

      {footer && (
        <div className="card-footer bg-white">
          {footer}
        </div>
      )}

    </div>
  );
};

export default PromotionSectionCard;